import { FIXED_DT_MS, MAX_CATCH_UP_STEPS, MAX_FRAME_DELTA_MS } from '../constants';

export class FixedStepClock {
  private previousMs = 0;
  private accumulatorMs = 0;
  private initialized = false;
  readonly stepMs: number;
  readonly maxSteps: number;
  readonly maxDeltaMs: number;
  alpha = 0;
  droppedFrames = 0;

  constructor(stepMs = FIXED_DT_MS, maxSteps = MAX_CATCH_UP_STEPS) {
    this.stepMs = stepMs;
    this.maxSteps = maxSteps;
    this.maxDeltaMs = Math.min(MAX_FRAME_DELTA_MS, stepMs * maxSteps);
  }

  reset(nowMs: number): void {
    this.previousMs = nowMs;
    this.accumulatorMs = 0;
    this.initialized = true;
    this.alpha = 0;
  }

  consume(nowMs: number): number {
    if (!this.initialized) {
      this.reset(nowMs);
      return 0;
    }
    let delta = nowMs - this.previousMs;
    this.previousMs = nowMs;
    if (delta < 0 || !Number.isFinite(delta)) delta = 0;
    if (delta > this.maxDeltaMs) {
      delta = this.maxDeltaMs;
      this.droppedFrames += 1;
    }
    this.accumulatorMs += delta;
    let steps = Math.floor((this.accumulatorMs + 0.000001) / this.stepMs);
    if (steps > this.maxSteps) steps = this.maxSteps;
    this.accumulatorMs -= steps * this.stepMs;
    if (this.accumulatorMs < 0) this.accumulatorMs = 0;
    if (this.accumulatorMs >= this.stepMs) this.accumulatorMs %= this.stepMs;
    this.alpha = this.accumulatorMs / this.stepMs;
    return steps;
  }
}
